const sv = {
  meta: {
    home: { title: "Centauros — Få betalt utan att jaga kunder", description: "Definiera betalningspolicyer, automatisera påminnelser, skapa fakturor och få betalt utan att jaga någon. Allt från mobilen." },
    privacy: { title: "Integritetspolicy — Centauros", description: "Hur Centauros skyddar och behandlar dina uppgifter." },
    terms: { title: "Användarvillkor — Centauros", description: "Villkor för att använda Centauros." },
    support: { title: "Support — Centauros", description: "Hjälp och svar om Centauros." },
    contact: { title: "Kontakt — Centauros", description: "Prata med Centauros-teamet." },
  },
  nav: { features: "Funktioner", how: "Så fungerar det", faq: "FAQ", contact: "Kontakt", download: "Ladda ner", dashboard: "Panel" },
  hero: {"line1": "Att få betalt borde inte", "line2": "vara ännu ett jobb.", "subtitle": "Sätt reglerna från början, automatisera uppföljningen och sluta jaga dina kunder för att få betalt.", "functional": "Med Centauros definierar du betalningspolicyer, automatiserar påminnelser, skapar fakturor och håller varje betalning under kontroll.", "ctaPrimary": "Ladda ner Centauros", "ctaSecondary": "Se hur det fungerar", "note": "Inga dolda avgifter · Säkra betalningar med Stripe", "availability": "Tillgänglig för iPhone och Android"},
  marquee: ["Byggt för hästproffs", "Säkert", "Snabbt", "Pålitligt", "Få betalt utan att jaga"],
  problem: {"label": "Problemet", "title": "Att få betalt är problemet. Bra arbete räcker inte om indrivning blir ännu ett jobb.", "intro": "Du får betalt sent, jagar dina kunder och ligger ute med tid, material och pengar. Det här är de verkliga kostnaderna.", "chapters": [{"n": "01", "title": "Betalningar som kommer sent", "text": "Du slutar med att finansiera kunden med din egen tid och dina pengar."}, {"n": "02", "title": "Jaga kunder", "text": "Obekväma meddelanden, samtal och mejl som borde gå att undvika."}, {"n": "03", "title": "Otydliga regler", "text": "När villkoren inte sätts från början skapar krav i efterhand konflikt."}, {"n": "04", "title": "Uteblivet utan överblick", "text": "Att inte veta vad du får in, när, eller vad som är förfallet."}, {"n": "05", "title": "Alternativkostnad", "text": "Varje timme du kräver betalning är en timme du inte arbetar eller vinner kunder."}]},
  solution: {
    label: "Lösningen",
    title: "Centauros automatiserar indrivningen, från början till slut.",
    subtitle: "Ställ in en gång. Låt det jobba åt dig.",
    items: ["Betalningspolicyer", "Påminnelser", "Fakturor", "Betalningar", "Uppföljning", "Avstämning"],
    footer: "Allt från mobilen.",
  },
  how: {
    label: "Så fungerar det",
    title: "Fyra steg. Noll friktion.",
    steps: [
      { title: "Skapa kund", text: "Lägg till din kund på några sekunder." },
      { title: "Välj policy", text: "Bestäm när och hur betalning sker automatiskt." },
      { title: "Skicka", text: "Centauros skapar och skickar fakturan åt dig." },
      { title: "Få betalt", text: "Betalningen kommer av sig själv. Utan manuella påminnelser." },
    ],
  },
  screens: {
    label: "Skärmar",
    title: "Designat med besatthet för detaljer.",
    subtitle: "Varje skärm byggd för att göra betalning osynlig.",
    items: [
      { title: "Indrivning", text: "Allt du har rätt till, med en blick." },
      { title: "Policyer", text: "Tydliga, återanvändbara betalningsregler." },
      { title: "Fakturor", text: "Skapa och skicka med en knapptryckning." },
      { title: "Betalningar", text: "Säkra, med Stripe, i realtid." },
    ],
  },
  features: {
    label: "Funktioner",
    title: "Allt du behöver för att få bättre betalt.",
    cards: [
      { title: "Full kontroll", text: "En tydlig bild av varje betalning och kund." },
      { title: "Automatisering", text: "Repetitiva uppgifter körs av sig själva." },
      { title: "Fakturering", text: "Professionella fakturor skapade direkt." },
      { title: "Indrivning", text: "Automatiska betalningar enligt dina policyer." },
      { title: "Team", text: "Bjud in ditt team och jobba tillsammans." },
      { title: "Säkerhet", text: "Säker infrastruktur och skyddad data." },
      { title: "Betalningar", text: "Få betalt med kort säkert via Stripe." },
      { title: "Historik", text: "Varje rörelse loggad och avstämd." },
    ],
  },
  audience: {
    label: "För vem",
    title: "Gjort för dem som lever på sitt arbete.",
    subtitle: "Om din tid är värdefull är Centauros för dig.",
    roles: ["Veterinärer", "Hovslagare", "Tränare", "Transportörer", "Hästproffs"],
    note: "Och alla proffs som vill få bättre betalt.",
  },
  security: {
    label: "Säkerhet",
    title: "Dina pengar och din data, skyddade.",
    subtitle: "Byggt på betrodd infrastruktur.",
    points: [
      { title: "Betalningar med Stripe", text: "Vi behandlar betalningar med branschens ledande standard." },
      { title: "Säker infrastruktur", text: "Kryptering under överföring och i vila." },
      { title: "Integritet", text: "Din data är din. Vi säljer den aldrig." },
      { title: "Dataskydd", text: "Efterlevnad och bästa praxis by design." },
      { title: "Inga sparade kort", text: "Vi lagrar aldrig kortuppgifter." },
    ],
  },
  faq: {
    label: "Vanliga frågor",
    title: "Allt du vill veta.",
    items: [
      { q: "Vad är Centauros?", a: "En app för att definiera betalningspolicyer, automatisera påminnelser, skapa fakturor och få betalt utan att jaga någon." },
      { q: "Behöver jag tekniska kunskaper?", a: "Nej. Det ställs in på några minuter och funkar från mobilen." },
      { q: "Hur behandlas betalningar?", a: "Betalningar behandlas säkert via Stripe." },
      { q: "Sparar ni mina kortuppgifter?", a: "Aldrig. Vi lagrar inga kortuppgifter någon gång." },
      { q: "Kan jag automatisera påminnelser?", a: "Ja. Definiera policyn en gång så sköter Centauros resten." },
      { q: "Kan jag skapa fakturor?", a: "Ja, professionella fakturor direkt, redo att skicka." },
      { q: "Fungerar det för mitt yrke?", a: "Byggt för hästproffs och alla som vill få bättre betalt." },
      { q: "Kan jag jobba med mitt team?", a: "Ja, du kan bjuda in ditt team och samarbeta." },
      { q: "Finns det på flera språk?", a: "Ja, Centauros finns på 12 språk." },
      { q: "Var kan jag ladda ner?", a: "Snart i App Store för iPhone." },
    ],
  },
  finalCta: { title: "Börja idag.", subtitle: "Ladda ner Centauros och sluta jaga kunder.", badge: "Ladda ner i App Store" },
  footer: {
    statement1: "Att få betalt är inte längre",
    statement2: "ännu ett jobb.",
    download: "Ladda ner Centauros",
    secure: "Säkra betalningar",
    tagline: "Få betalt utan att jaga kunder.",
    colProduct: "Produkt", colCompany: "Företag", colLegal: "Juridik",
    links: { home: "Hem", features: "Funktioner", faq: "FAQ", contact: "Kontakt", privacy: "Integritet", terms: "Villkor", support: "Support", download: "Ladda ner" },
    contactLabel: "Kontakt",
    rights: "© Centauros. Alla rättigheter förbehållna.",
  },
  contact: {
    title: "Låt oss prata.",
    subtitle: "Har du en fråga eller vill veta mer? Skriv till oss.",
    fields: { name: "Namn", email: "E-post", subject: "Ämne", message: "Meddelande" },
    placeholders: { name: "Ditt namn", email: "du@email.com", subject: "Hur kan vi hjälpa?", message: "Berätta för oss..." },
    submit: "Skicka meddelande", sending: "Skickar...", success: "Meddelande skickat. Vi hör av oss snart.", error: "Kunde inte skicka. Försök igen.", directLabel: "Eller skriv direkt till oss på",
  },
  legal: {
    privacy: {
      title: "Integritetspolicy", updated: "Senast uppdaterad: juni 2026",
      body: [
        { h: "Introduktion", p: "På Centauros tar vi din integritet på allvar. Denna policy förklarar vilka uppgifter vi behandlar och varför." },
        { h: "Uppgifter vi behandlar", p: "Vi behandlar de uppgifter som behövs för tjänsten: ditt konto, kunderna du hanterar och betalningarna du gör." },
        { h: "Betalningar", p: "Betalningar går via Stripe. Vi lagrar aldrig dina eller dina kunders kortuppgifter." },
        { h: "Användning av uppgifter", p: "Vi använder dina uppgifter bara för att leverera och förbättra tjänsten. Vi säljer aldrig din information." },
        { h: "Dina rättigheter", p: "Du kan när som helst få tillgång till, rätta eller radera dina uppgifter via support@centauros.app." },
      ],
    },
    terms: {
      title: "Användarvillkor", updated: "Senast uppdaterad: juni 2026",
      body: [
        { h: "Godkännande", p: "Genom att använda Centauros godkänner du dessa villkor. Om du inte samtycker, använd inte tjänsten." },
        { h: "Användning av tjänsten", p: "Du åtar dig att använda Centauros lagligt och hålla ditt konto säkert." },
        { h: "Betalningar", p: "Betalningar behandlas via Stripe enligt deras villkor. Du ansvarar för dina kundrelationer." },
        { h: "Ansvar", p: "Centauros tillhandahålls \"i befintligt skick\". Vi arbetar för fortsatt tillgänglighet och säkerhet." },
        { h: "Ändringar", p: "Vi kan uppdatera dessa villkor. Relevanta ändringar meddelas via appen." },
      ],
    },
    support: {
      title: "Support", updated: "Vi finns här för att hjälpa.",
      intro: "Hitta snabba svar eller kontakta oss direkt. Vi svarar så snart som möjligt.",
      faqs: [
        { q: "Hur börjar jag?", a: "Ladda ner appen, skapa ditt konto och lägg till din första kund på några minuter." },
        { q: "Hur automatiserar jag indrivning?", a: "Skapa en betalningspolicy och tilldela den till dina kunder. Resten är automatiskt." },
        { q: "Jag har ett betalningsproblem?", a: "Skriv till support@centauros.app så tittar vi på det tillsammans." },
        { q: "Kan jag exportera mina data?", a: "Ja, du kan begära en export när som helst." },
      ],
      contactLine: "Behöver du mer hjälp? Skriv till oss på",
    },
  },
  common: { languageLabel: "Språk", backHome: "Tillbaka till start", loading: "Laddar..." },
  philosophy: {"label": "Filosofin", "title": "Betalningsreglerna sätts", "titleGreen": "innan du börjar.", "text": "Ibland är det bättre att tacka nej till en kund än att ta en som tvingar dig att ligga ute med tid, pengar och resurser utan att veta när du får betalt. Med Centauros kommer du överens från början om hur, när och hur mycket som ska betalas.", "points": ["Definiera betalningspolicyer", "Förebygga problem", "Säkra åtaganden", "Automatisera uppföljning", "Behålla ekonomisk kontroll", "Minska friktion med kunden"]},
  showcase: {"label": 'Produkten', "slides": [{"id": "control", "title": "Ha koll på allt", "green": "du ska driva in", "text": "En tydlig bild av varje betalning och ditt företag, alltid till hands."}, {"id": "policies", "title": "Du bestämmer", "green": "hur och när du får betalt", "text": "I förskott, deposition + rest, vid slutförande eller återkommande. Välj rätt policy."}, {"id": "clients", "title": "Varje kund,", "green": "all info du behöver", "text": "Uppgifter, betalningar, prenumerationer och historik på ett ställe."}, {"id": "payments", "title": "Varje betalning,", "green": "under kontroll", "text": "Realtidsstatus, automatiska påminnelser och faktura direkt."}, {"id": "impagos", "title": "Upptäck uteblivna", "green": "innan de växer", "text": "Centauros följer upp, kräver och hjälper dig återkräva det förfallna."}, {"id": "facturacion", "title": "Betalningar och fakturor", "green": "alltid avstämda", "text": "Skapa, granska och stäm av alla dina fakturor från ett ställe."}, {"id": "equipo", "title": "Ditt team,", "green": "allt under kontroll", "text": "Bjud in teamet, tilldela roller och hantera indrivningen tillsammans."}]},
  badges: {"appStoreTop": "Ladda ner i", "appStoreLabel": "App Store", "playTop": "Hämta på", "playLabel": "Google Play"},
  partners: {"label": "Drivs av ledande betalningspartner"},
  dashboard: {
    loginTitle: "Centauros-panel", loginSubtitle: "Privat adminåtkomst.",
    email: "E-post", password: "Lösenord", signIn: "Logga in", signingIn: "Loggar in...", invalid: "Ogiltiga uppgifter.", logout: "Logga ut",
    nav: { overview: "Översikt", users: "Användare", workspaces: "Arbetsytor", activity: "Aktivitet", incidents: "Incidenter" },
    metrics: { users: "Totala användare", active: "Aktiva användare", workspaces: "Arbetsytor", incidents: "Öppna incidenter", collected: "Totalt indrivet" },
    tableUsers: { name: "Namn", email: "E-post", profession: "Yrke", status: "Status" },
    tableWorkspaces: { name: "Arbetsyta", members: "Medlemmar", plan: "Plan", collected: "Indrivet" },
    tableIncidents: { title: "Titel", workspace: "Arbetsyta", severity: "Allvar", status: "Status" },
    recentActivity: "Senaste aktivitet",
  },
  policies: {
    label: "Betalningspolicyer",
    title: "Du bestämmer hur och när du får betalt.",
    subtitle: "Ställ in policyn som passar varje kund så tillämpar Centauros den automatiskt.",
    methods: [
      { name: "Förskottsbetalning", desc: "Ta betalt hela beloppet innan du börjar. Noll risk." },
      { name: "Handpenning + slutbetalning", desc: "En handpenning nu och resten när jobbet är klart." },
      { name: "Betalning vid slutförande", desc: "Kunden betalar automatiskt när du är klar." },
      { name: "Återkommande betalning", desc: "Abonnemang och avgifter som dras automatiskt varje period." },
      { name: "Senare tillägg", desc: "Lägg till extra avgifter efter tjänsten, helt friktionsfritt." },
      { name: "Betalning per delmål", desc: "Dela upp betalningen i faser och få betalt allt eftersom." },
    ],
    ui: { upfront: "Förskott", paid: "Betald", pending: "Väntar", total: "Totalt", deposit: "Handpenning", balance: "Rest", completed: "Slutförd", dueOnFinish: "Vid slutförande", monthly: "Månadsvis", nextCharge: "Nästa dragning", extra: "Tillägg", milestone: "Delmål" },
  },
  redesign: { comingSoon: "Kommer snart" },
  appui: { hello: "Hej", toCollect: "Att ta betalt", collected: "Mottaget", overdue: "Förfallen", activity: "Aktivitet", pending: "Väntar", paid: "Betald", advance: "Förskott", extra: "Tillägg", payNow: "Betala nu" },
  faqx: [
    { q: "Vad är Centauros?", a: "Centauros är en plattform för att definiera betalningspolicyer, automatisera betalningar, skapa fakturor och minska sena betalningar utan att jaga dina kunder. Du ställer in dina regler en gång och appen tar betalt, påminner och stämmer av åt dig." },
    { q: "Vem är det för?", a: "För alla yrkespersoner eller företag som fakturerar sina tjänster: tränare, veterinärer, advokater, konsulter, byråer, kliniker, gym eller tjänsteföretag. Oavsett om du fakturerar återkommande eller per projekt anpassar sig Centauros efter ditt sätt att arbeta." },
    { q: "Måste mina kunder installera appen?", a: "Nej. Dina kunder får betalningslänkar och meddelanden direkt, utan att ladda ner något. Bara du, yrkespersonen, använder Centauros-appen." },
    { q: "Vilka betalmetoder kan jag ta emot?", a: "Tack vare Stripe kan du ta emot kredit- och betalkort, Apple Pay, Google Pay och övriga metoder som finns i ditt land. De exakta metoderna beror på Stripes täckning i varje region." },
    { q: "Kan jag bestämma hur och när jag får betalt?", a: "Ja. Förskottsbetalning, handpenning + slutbetalning, betalning vid slutförande, återkommande betalningar, senare tillägg eller betalning per delmål. Du väljer policyn som passar varje kund eller tjänst." },
    { q: "Skapar Centauros fakturor automatiskt?", a: "Ja. Det kan skapa utkast, utfärda fakturor automatiskt efter betalning eller följa den faktureringspolicy du ställer in. Alla registreras och är redo att skicka." },
    { q: "Vad händer om en kund inte betalar?", a: "Centauros sköter uppföljningen åt dig: automatiska påminnelser, bevakning av förfallodatum och markering av sena betalningar, så att du får in det utestående utan obekväma samtal." },
    { q: "Är Centauros säkert?", a: "Ja. Betalningar hanteras helt via Stripe, data överförs krypterat och vi lagrar aldrig kortuppgifter. Plattformen följer god säkerhetspraxis." },
    { q: "I vilka länder är det tillgängligt?", a: "Centauros är byggt för att fungera internationellt. Tillgängliga betalmetoder beror på de länder som Stripe stöder, vilket täcker de flesta marknader i Europa, Amerika och andra regioner." },
    { q: "Hur kommer jag igång?", a: "Ladda ner appen, skapa ditt konto och ställ in din första betalningspolicy på några minuter. Därifrån kan du börja ta betalt och automatisera dina betalningar." },
  ],
  legalx: {
    eyebrow: "Juridiskt", contents: "Innehåll", questions: "Frågor om denna sida? Hör av dig.",
    navPrivacy: "Integritet", navTerms: "Villkor", navCookies: "Cookies", navSupport: "Support",
    cookiesMetaTitle: "Cookiepolicy — Centauros", cookiesMetaDesc: "Hur Centauros använder cookies och liknande tekniker.",
  },
  product2: {
    p1title: "Sluta jaga. Börja få betalt.",
    p1sub: "Manuell påminnelse gör att du förlorar pengar. Med Centauros sätter du policyn och får betalt automatiskt, utan obekväma samtal.",
    p1cta: "Ladda ner Centauros",
    p1link: "Se hur det fungerar",
    p1cardTitle: "Av varje 1 000 € fakturerat",
    p1cardCol: "Får du faktiskt in",
    p1rows: [
      { name: "Centauros", amount: "1 000 €" },
      { name: "Manuella påminnelser", amount: "910 €", delta: "−90 €" },
      { name: "Utan uppföljning", amount: "820 €", delta: "−180 €" },
    ],
    p2title: "Få betalt för ditt arbete, utan friktion.",
    p2sub: "Betallänkar, policyer och automatiska fakturor. Du sätter reglerna en gång och Centauros sköter resten.",
    p2cta: "Se hur det fungerar",
    p2policy: "Policy · Handpenning + slutbetalning",
    p2sendLabel: "Kunden betalar",
    p2client: "Kund",
    p2info: "Återkommande betalning? Ställ in en gång så dras den automatiskt varje period.",
    p2recipLabel: "Du får",
    p2you: "Du",
    p2arrives: "Indraget",
    p2arrivesVal: "Idag · automatiskt",
    p2fees: "Avgifter",
    p2feesVal: "Ingår",
    p3title: "Gör så mycket mer med Centauros.",
    p3sub: "Det handlar inte bara om att få betalt: hantera kunder, fakturor, obetalda fordringar och ditt team på ett ställe.",
    p3cta: "Skapa konto",
    p3cardLabel: "Att få in",
    p3feat: "Få betalt direkt",
    p3featDesc: "Betallänkar och automatiska indrag som drivs av Stripes infrastruktur.",
    p3check: "Flera betalmetoder",
    p3cta2: "Utforska betalningar",
    p4title: "Få tillbaka de obetalda fordringar du redan skrivit av.",
    p4sub: "Centauros driver automatiskt in försenade betalningar med påminnelser och nya försök, tills du får betalt.",
    p4cta: "Se hur det fungerar",
    p4cardLabel: "Återvunna fordringar",
    p4foot: "Yrkesverksamma får i snitt tillbaka 38 % mer i obetalda fordringar under de första 6 månaderna.",
  },
  pricing: {
    label: "Priser",
    title: "Tydliga priser. Inga överraskningar.",
    subtitle: "Du betalar bara när du får betalt. Stripe tar sin avgift för att behandla betalningen och Centauros lägger till 1 % för automatiseringen, indrivningen och hela plattformen.",
    stripeTitle: "Stripe-avgift",
    stripeDesc: "Stripe behandlar betalningen säkert. Avgiften varierar beroende på land och betalmetod; exemplet som visas gäller europeiska kort.",
    centaurosTitle: "Centauros-avgift",
    centaurosDesc: "1 % av beloppet för automatisering, uppföljning av betalningar och hela plattformen. Inga dolda månadsavgifter.",
    calcTitle: "Räkna ut vad du får",
    invoiceAmount: "Fakturabelopp",
    stripeFee: "Stripe-avgift",
    centaurosFee: "Centauros-avgift (1 %)",
    received: "Den yrkesverksamma får",
    note: "Stripes faktiska avgift kan variera beroende på land och betalmetod. Beloppen som visas är ett vägledande exempel.",
  },
  cookie: {
    title: "Din integritet, ditt val",
    intro: "Vi använder cookies för att Centauros ska fungera korrekt, komma ihåg dina inställningar och för att anonymt förstå hur webbplatsen används. Du väljer vad som aktiveras och kan ändra dig när som helst.",
    required: "Alltid på",
    acceptAll: "Acceptera alla",
    rejectAll: "Avvisa alla",
    save: "Spara inställningar",
    reopen: "Cookie-inställningar",
    footnote: "Du kan ändra ditt samtycke när som helst via sidfoten.",
    policyLink: "Cookiepolicy",
    categories: {
      necessary: { name: "Nödvändiga", desc: "Avgörande för att webbplatsen ska fungera och vara säker. De kan inte stängas av." },
      preferences: { name: "Inställningar", desc: "Kommer ihåg dina val, som språk, för en smidigare upplevelse." },
      analytics: { name: "Analys", desc: "Hjälper oss att anonymt förstå hur webbplatsen används så att vi kan förbättra den." },
      marketing: { name: "Marknadsföring", desc: "Gör det möjligt att visa mer relevant innehåll och annonser, på och utanför webbplatsen." },
    },
  },
};
export default sv;
